<p style="
        margin-top: 0px;
        font-size: 2.1rem;
        color: var(--bs-active-primary);
        font-weight: 900;
    ">
  <a routerLink="/bizz/customers-list" class="p-button font-bold">
      <span  class="pi pi-arrow-circle-left text-2xl text-muted-color"></span>
    </a>
  Customer Details
</p>
<div class="grid" >
    <div class="col">
        <p-skeleton width="100%" height="4rem" *ngIf="isSubscriptionDetailsLoading"></p-skeleton>
        <div class="conn-card" *ngIf="!isSubscriptionDetailsLoading">
            <app-bizz-customer-personal-info ></app-bizz-customer-personal-info>
        </div>
    </div>
</div>

<div class="conn-grid-main create-product" >
    <h4>Subscription</h4>
    <p-skeleton width="100%" height="7rem"  *ngIf="isSubscriptionDetailsLoading"></p-skeleton>
    <div *ngIf="!isSubscriptionDetailsLoading">
        <p-tabMenu #tab
            [model]="items"
            [activeItem]="activeItem"
            [scrollable]="true"
            (click)="onTabItemClick(tab)">
        </p-tabMenu>
        <div *ngIf="activeItem?.label === 'Subscription'" class="fadeinright animation-duration-200 mt-3">
            <div class="conn-card">
                <div class="conn-grid ">
                    <!-- <app-subscription
                        [planInfo]="planInfo"
                        [businessSetup]="businessSetup"
                    >
                    </app-subscription> -->
                    <app-subscription-detail-of-customer>

                    </app-subscription-detail-of-customer>
                </div>
            </div>
            <!-- <div class="grid">
                <div class="col">
                    <div class="conn-card">
                        <app-bizz-customer-personal-info></app-bizz-customer-personal-info>
                    </div>
                </div>
            </div> -->
            <!-- <div class="grid" *ngIf="_bizzCustomerService.activeItem.isSubscriptionCompleted">
                <div class="col">
                    <div class="conn-card">
                        <app-bizz-customer-subscription-invoice></app-bizz-customer-subscription-invoice>
                    </div>
                </div>
            </div> -->
        </div>
        <div *ngIf="activeItem?.label === 'Plan Configuration' && activeItem?.visible"
            class="fadeinright animation-duration-200 mt-3">
            <app-bizz-customer-plan-configuration></app-bizz-customer-plan-configuration>
        </div>
        <div *ngIf="activeItem?.label === 'Billing Address' && activeItem?.visible"
            class="fadeinright animation-duration-200 mt-3">
            <div class="conn-card">
                <div class="conn-grid ">
                    <app-billing-address></app-billing-address>
                </div>
            </div>
        </div>
        <div *ngIf="activeItem?.label === 'Billing History' && activeItem?.visible" class="fadeinright animation-duration-200 mt-3">
            <div class="conn-card">
                <div class="conn-grid ">
                    <app-billing-history></app-billing-history>
                </div>
            </div>
        </div>
        <div *ngIf="activeItem?.label === 'Hardware' && activeItem?.visible" class="fadeinright animation-duration-200 mt-3">
            <div class="conn-card">
                <div class="conn-grid ">
                    <app-bizz-customer-hardware-details></app-bizz-customer-hardware-details>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- <div class="grid">
    <div class="col">
        <div class="conn-card">
            <app-bizz-cash-discount-configuration></app-bizz-cash-discount-configuration>
        </div>
    </div>
</div> -->

<!-- <div class="grid">
    <div class="col">
        <div class="conn-card">
            <app-subscription-detail-of-customer></app-subscription-detail-of-customer>
        </div>
    </div>
</div> -->


<!-- <div class="grid">
    <div class="col">
        <div class="conn-card">
            <app-bizz-customer-personal-info></app-bizz-customer-personal-info>
        </div>
    </div>
</div>

<div class="nas-grid-2x">
    <div class="col" *ngIf="_bizzCustomerService.activeItem.subscriptionInvoice?.plans">
        <div class="conn-card">
            <app-bizz-customer-subscription-plan-details></app-bizz-customer-subscription-plan-details>
        </div>
    </div>
    <div class="col" *ngIf="_bizzCustomerService.activeItem.subscriptionInvoice?.hardwarePkg">
        <div class="conn-card">
            <app-bizz-customer-hardware-details></app-bizz-customer-hardware-details>
        </div>
    </div>
</div>

<div class="grid" *ngIf="_bizzCustomerService.activeItem.isSubscriptionCompleted">
    <div class="col">
        <div class="conn-card">
            <app-bizz-customer-subscription-invoice></app-bizz-customer-subscription-invoice>
        </div>
    </div>
</div> -->

